<template>
  <div class="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
    <div class="bg-base-100 rounded-lg shadow-lg p-6 w-96">
      <h4 class="text-lg font-semibold mb-4">Merge Colors Settings</h4>
      <div class="space-y-4">
        <div class="form-control">
          <label class="label">
            <span class="label-text font-medium">Merge Threshold (1-100):</span>
          </label>
          <input
            type="number"
            v-model.number="threshold"
            min="1"
            max="100"
            class="input input-bordered w-full"
          />
          <label class="label">
            <span class="label-text-alt text-neutral-500"
              >Higher values will merge more similar colors</span
            >
          </label>
        </div>
      </div>
      <div class="flex justify-end gap-4 mt-6">
        <button @click="confirmMerge" class="btn btn-primary">Confirm</button>
        <button @click="$emit('close')" class="btn">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

const emit = defineEmits<{
  (e: "merge", threshold: number): void;
  (e: "close"): void;
}>();

const threshold = ref(20);

const confirmMerge = () => {
  if (threshold.value < 1 || threshold.value > 100) {
    alert("Please enter a merge threshold between 1 and 100");
    return;
  }
  emit("merge", threshold.value);
};
</script>

<style scoped></style>
